import { HaNContext, HaNFilterBarContext } from "@lib/logic";
import { getShouldShowHereAndNowConnectYourCalendarFullScreen, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";
import { ChipFilterNew } from "@molecules";

export const RoomsFilters = () => {
  const { tab } = useRequiredContext(HaNContext);

  if (tab !== "rooms") return null;

  return <RoomsFiltersContent />;
};

// Without a calendar there are no rooms to filter, only the request to connect one
const RoomsFiltersContent = () => {
  const isAskingForCalendar = useAppSelector(getShouldShowHereAndNowConnectYourCalendarFullScreen);
  const { areFiltersTransparent } = useRequiredContext(HaNFilterBarContext);

  if (isAskingForCalendar) return null;

  return (
    <ChipFilterNew
      filterSlice="HereAndNow_Rooms"
      testIdPrefix="HaNRoomFilters"
      areFilterTransparent={areFiltersTransparent}
    />
  );
};
